import React, { useEffect, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  Tooltip,
  TextField,
  Slider,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  CircularProgress,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../context/AuthContext";

const getFilters = ({ filters, setFilters }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [chambers, setChambers] = useState([]);

  const { setNotification } = useAuthContext();
  const handleChamberOpen = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/getChambers`,
        {
          withCredentials: true,
        },
      );

      setChambers(() => response.data);
    } catch (error) {
      setNotification({
        open: true,
        color: "error",
        message: "Σφάλμα συστήματος προσπαθήστε ξανά",
      });
    } finally {
      setLoading(false);
    }
  };

  const sliderMarks = [
    {
      value: 2017,
      label: "Όλα",
    },
    {
      value: 2018,
      label: "2018",
    },
    {
      value: 2019,
      label: "2019",
    },
    {
      value: 2020,
      label: "2020",
    },
  ];

  const paidStates = [
    {
      status: "Εμβασματοποιημένη",
      value: "8",
    },
    {
      status: "Σε Εκρεμμότητα",
      value: "3",
    },
    {
      status: "Ελλατωματική",
      value: "9",
    },
  ];

  const unpaidStates = [
    {
      status: "Μερικώς Πληρωμένη",
      value: "-1",
    },
    {
      status: "Απλήρωτη",
      value: "2",
    },
  ];

  return [
    {
      title: "Ημερομηνία Βεβαίωσης",
      details: (
        <>
          <DatePicker
            label="Απο:"
            componentsProps={{
              actionBar: {
                actions: ["clear"],
              },
            }}
            value={filters.dateFromConfirmation}
            onChange={(newValue) => {
              setFilters({ ...filters, dateFromConfirmation: newValue });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderRadius: "0px",
                      borderTop: "none",
                      borderRight: "none",
                      borderLeft: "none",
                    },
                  },
                }}
              />
            )}
          />
          <DatePicker
            componentsProps={{
              actionBar: {
                actions: ["clear"],
              },
            }}
            label="Έως:"
            value={filters.dateToConfirmation}
            onChange={(newValue) => {
              setFilters({ ...filters, dateToConfirmation: newValue });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderRadius: "0px",
                      borderTop: "none",
                      borderRight: "none",
                      borderLeft: "none",
                    },
                  },
                }}
              />
            )}
          />
        </>
      ),
    },
    {
      title: "Ημερομηνία Είσπραξης",
      details: (
        <>
          <DatePicker
            componentsProps={{
              actionBar: {
                actions: ["clear"],
              },
            }}
            label="Απο:"
            value={filters.dateFromPayment}
            onChange={(newValue) => {
              setFilters({ ...filters, dateFromPayment: newValue });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderRadius: "0px",
                      borderTop: "none",
                      borderRight: "none",
                      borderLeft: "none",
                    },
                  },
                }}
              />
            )}
          />
          <DatePicker
            componentsProps={{
              actionBar: {
                actions: ["clear"],
              },
            }}
            label="Έως:"
            value={filters.dateToPayment}
            onChange={(newValue) => {
              setFilters({ ...filters, dateToPayment: newValue });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderRadius: "0px",
                      borderTop: "none",
                      borderRight: "none",
                      borderLeft: "none",
                    },
                  },
                }}
              />
            )}
          />
        </>
      ),
    },
    {
      title: "Έτος Οφειλής",
      details: (
        <>
          <Slider
            sx={{ width: "80%", ml: 3 }}
            aria-label="Year"
            value={filters.yearOfConfirmation}
            valueLabelDisplay={
              filters.yearOfConfirmation == 2017 ? "off" : "auto"
            }
            step={1}
            onChange={(event) => {
              setFilters({
                ...filters,
                yearOfConfirmation: event.target.value,
              });
            }}
            marks={sliderMarks}
            min={2017}
            max={2020}
          />
        </>
      ),
    },
    {
      title: "Κατάσταση Πληρωμής",
      details: (
        <>
          <FormControl
            variant="standard"
            sx={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <InputLabel id="select_paid">Κατάσταση</InputLabel>
            <Select
              IconComponent={
                filters.paidStatus != ""
                  ? () => (
                      <ClearIcon
                        size="small"
                        sx={{ cursor: "pointer" }}
                        onClick={(e) => {
                          setFilters({ ...filters, paidStatus: "" });
                        }}
                      />
                    )
                  : undefined
              }
              labelId="select_paid"
              value={filters.paidStatus}
              onChange={(event) => {
                setFilters({ ...filters, paidStatus: event.target.value });
              }}
            >
              {searchParams.get("tab") == "paid"
                ? paidStates.map((it, index) => (
                    <MenuItem key={index} value={it.value}>
                      {it.status}
                    </MenuItem>
                  ))
                : unpaidStates.map((it, index) => (
                    <MenuItem key={index} value={it.value}>
                      {it.status}
                    </MenuItem>
                  ))}
            </Select>
          </FormControl>
        </>
      ),
    },
    {
      title: "Επιμελητήριο Οφειλής",
      details: (
        <>
          <FormControl variant="standard" sx={{ width: "100%" }}>
            <InputLabel id="select_chamber">Επιμελητήριο</InputLabel>
            <Tooltip
              title={
                chambers[filters.chamber - 1]
                  ? chambers[filters.chamber - 1].label
                  : ""
              }
              placement="top"
              PopperProps={{
                disablePortal: true,
                popperOptions: {
                  positionFixed: true,
                  modifiers: {
                    preventOverflow: {
                      enabled: true,
                      boundariesElement: "window", // where "window" is the boundary
                    },
                  },
                },
              }}
            >
              <Select
                value={filters.chamber}
                onOpen={handleChamberOpen}
                IconComponent={
                  filters.chamber != ""
                    ? () => (
                        <ClearIcon
                          size="small"
                          sx={{ cursor: "pointer" }}
                          onClick={(e) => {
                            setFilters({ ...filters, chamber: "" });
                          }}
                        />
                      )
                    : undefined
                }
                onChange={(event) => {
                  setFilters({ ...filters, chamber: event.target.value });
                }}
              >
                {loading || chambers.length <= 0 ? (
                  <CircularProgress size={25} sx={{ ml: "40%", mt: 1 }} />
                ) : (
                  chambers.map((chamber, index) => (
                    <MenuItem key={index} value={chamber.id}>
                      {chamber.label}
                    </MenuItem>
                  ))
                )}
              </Select>
            </Tooltip>
          </FormControl>
        </>
      ),
    },
  ];
};

export default getFilters;
